import type { State } from 'src/store/types';
import type { AbstractPageView } from 'src/pages/abstract-page-view';
import type { ScreensPageViewModel, Screen } from 'src/pages/screens-page/screens-page-view-model';
import { mapApiOrderStatus } from 'src/content/screens/screen-order-status';
import { weekScheduleDescription } from 'src/store/selectors/employees/work-hours-description';

function getScreensData(_organizationId: number, hrefPrefix: string, state: State): Screen[] {
  // Infoskjerm er tilgjengelig for alle kunder. Synligheten av selve siden styres
  // av bransje/aktivitet via den backend-genererte sidestrukturen (pageGroups),
  // ikke av et feature flag. Her henter vi bare skjermene fra Redux state.
  const screens = state.organization?.screens ?? [];
  // Map til Screen format som forventes av UI
  return screens.map((screen) => {
    // Bestillingsstatus leses fra backend-feltet (dabih-api #4591) i stedet for
    // å avledes av [A]-prefiks/playerConnected (#13126).
    const orderStatus = mapApiOrderStatus(screen.orderStatus);
    return {
      id: screen.displayId.toString(),
      name: screen.name,
      href: `${hrefPrefix}screens/${screen.displayId}`,
      screenshotUrl: screen.screenshotUrl,
      previewUrl: screen.previewUrl,
      schedule: screen.workWeek ? weekScheduleDescription(screen.workWeek) : '',
      orderStatus,
    };
  });
}

export function screensPageView(hrefPrefix: string, viewModel: AbstractPageView, state: State): ScreensPageViewModel {
  const o = state.organization;
  if (o === undefined) {
    throw new Error('Illegal state (E151), organization not found');
  }
  return {
    ...viewModel,
    type: 'screens-page',
    icon: 'screens',
    href: hrefPrefix,
    screens: getScreensData(o.organizationId, hrefPrefix, state),
  };
}
